export const SUMMARY_DIMENSIONS = {
  WIDTH: 280,
  HEIGHT: 139,
} as const;

export const SKELETON_CONFIG = {
  WIDTHS: [280, 220, 260, 180, 250, 200, 240, 160, 210],
} as const;
